module.exports = __webpack_public_path__ + "static/media/construction.e882ef66.svg";